var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{ref:"textarea",domProps:{"value":_vm.code},on:{"input":_vm.updateCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }